<app-complex-modal-template
    class="overflow-visible"
    [canConfirm]="formGroup()?.valid ?? false"
    [title]="'addUser' | transloco"
    (onClickEvent)="closeModal($event)">
    @if (formGroup()) {
        <form
            class="flex flex-col gap-5 pb-11"
            [formGroup]="formGroup()!">
            <div class="flex flex-row gap-7">
                <div class="flex flex-col gap-0.5 w-2/4">
                    <app-input-text
                        data-testid="user-name-input"
                        [disabled]="!canManageUser()"
                        [inputFormControl]="formGroup()!.controls.name"
                        [label]="'name' | transloco"
                        [matTooltip]="manageUserTooltip()"
                        [placeholder]="'enterName' | transloco" />
                </div>
                <div class="flex flex-col gap-0.5 w-2/4">
                    <app-input-text
                        data-testid="user-given-name-input"
                        [disabled]="!canManageUser()"
                        [inputFormControl]="formGroup()!.controls.firstName"
                        [label]="'givenName' | transloco"
                        [matTooltip]="manageUserTooltip()"
                        [placeholder]="'enterFirstname' | transloco" />
                </div>
            </div>
            <div class="flex flex-row gap-7">
                <app-input-text
                    class="grow"
                    data-testid="user-email-input"
                    [disabled]="!canManageUser()"
                    [errors]="mailIsValid(formGroup()!, mailError()) ? [mailIsValid(formGroup()!, mailError())!] : []"
                    [inputFormControl]="formGroup()!.controls.mail"
                    [label]="'email' | transloco"
                    [matTooltip]="manageUserTooltip()"
                    [placeholder]="'enterEmail' | transloco" />

                <div class="flex flex-col gap-0.5">
                    <label class="font-normal text-base">{{ 'license' | transloco }}</label>

                    <app-licenses-select (onLicensesChange)="onLicensesChange($event)" />
                </div>
            </div>

            <div class="flex flex-row gap-7">
                <div
                    class="flex flex-col gap-0.5 w-2/4"
                    [class.opacity-40]="!connectServicesLicense() || !canManageUser()">
                    <label class="font-normal text-base">{{ 'role' | transloco: { COUNT: 1 } }}</label>

                    <app-select
                        class=""
                        placeholder="selectRole"
                        [isDisabled]="!connectServicesLicense() || !canManageUser()"
                        [matTooltip]="roleTooltip()"
                        [options]="roles()"
                        [(selectedOptions)]="rolesSelected"
                        (optionSelected)="onSelectedRoleChange($event)" />
                </div>

                <div
                    class="flex flex-col gap-0.5 w-2/4"
                    [class.opacity-40]="!canEditProject()">
                    <label class="font-normal text-base">{{ 'project' | transloco: { COUNT: 1 } }}(s)</label>

                    <app-select
                        class="w-full"
                        [isDisabled]="!canEditProject()"
                        [isMultiSelect]="true"
                        [matTooltip]="(!canEditProject() ? 'insufficientPermissions' : '') | transloco"
                        [options]="projects()"
                        [placeholder]="'selectProjects' | transloco: { COUNT: projects().length }"
                        (optionSelected)="onSelectedProjectsChange($event)" />
                </div>
            </div>

            <div class="flex flex-row gap-7 w-[48%]">
                <div class="flex flex-col gap-0.5 w-full">
                    <app-input-number
                        [disabled]="streetViewQuotaDisabled() || !canManageUser()"
                        [inputFormControl]="formGroup()!.controls.streetViewQuota"
                        [label]="'streetView.requestQuota' | transloco"
                        [matTooltip]="streetViewQuotaTooltipUi() | transloco"
                        [max]="allocatableQuota() ?? 0"
                        [min]="0"
                        [placeholder]="streetViewQuotaDisabled() || !canManageUser() ? '' : undefined" />
                    @if (allocatableQuota() !== null) {
                        <span>
                            {{ 'streetView.grantedRequest' | transloco: { count: allocatableQuota() } }}
                        </span>

                        @if (securityService.meSignal()!.organization.streetViewQuotaRemaining) {
                            <span class="pt-2">
                                {{
                                    'streetView.remainingRequest'
                                        | transloco
                                            : {
                                                  count: securityService.meSignal()!.organization
                                                      .streetViewQuotaRemaining,
                                              }
                                }}
                            </span>
                        }
                    }
                </div>
            </div>
        </form>
    }
</app-complex-modal-template>
